export default "__VITE_ASSET__y1JXK58I__"